import React  from 'react';

import UserIcon from 'core/gd-components/icons/user-icon';

export default function renderUrlGroupTListHeader1(id, props) {
    const user = gd.session.users.get(props.data.value);

    return (
        <React.Fragment>
            {!!user && <UserIcon className="m-r-10" size="22" userId={props.data.value}/>}
            <div className="text ui5-txt-default">{user ? user.name : 'No user'}</div>
        </React.Fragment>
    );
}